import React from 'react';
import { FormGroup } from '@wheely/ui-kit';

import { UserInputError } from '../UserInputError';
import { ITextInputProps, TextInput } from '../../components/TextInput';
import s from '../styles.module.css';

interface ITextFieldProps<N extends string> extends ITextInputProps<N> {
  error?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  inputRef?: React.ForwardedRef<HTMLInputElement>;
  dataTestId?: string;
  inputDataTestId?: string;
}

const TextField = <N extends string = string>({
  name,
  value,
  onChange,
  error,
  title,
  description,
  placeholder,
  inputRef,
  isDisabled,
  inputDataTestId,
  dataTestId = 'form-text-field',
  startElem,
  onBlur,
}: ITextFieldProps<N>) => (
  <div data-test-id={dataTestId}>
    <FormGroup
      title={title}
      error={error && <UserInputError>{error}</UserInputError>}
      description={
        !error && description && <div data-test-id={`${dataTestId}__note`}>{description}</div>
      }
      formGroupProps={{ className: s.formGroup }}
    >
      <TextInput<N>
        dataTestId={inputDataTestId}
        isDisabled={isDisabled}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        ref={inputRef}
        hasError={!!error}
        startElem={startElem}
        onBlur={onBlur}
      />
    </FormGroup>
  </div>
);

export type { ITextFieldProps };
export { TextField };
